import DashboardContext from 'actions/context/DashboardContext';

export const SET_DASHBOARD_CONTEXT = 'SET_DASHBOARD_CONTEXT';

export const setDashboardContext = ctx => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: SET_DASHBOARD_CONTEXT,
      ctx: new DashboardContext(ctx),
    });
    resolve();
  });



// WEBPACK FOOTER //
// ./app/actions/context/index.js